import { z } from 'zod';
/** A name graph rows refer to: an event, a form item, a signal. */
export const snakeKey = z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-z][a-z0-9_]*$/, 'lower_snake_case');
//# sourceMappingURL=keys.js.map